export default function wordCloudLoader(clusterI) {
    // clusterI is an array containing cluster indexes
    let images = []

    for (let i in clusterI) {
        images.push({id: i, src: `src/components/images/wordcloud_cluster_${i}.png`})
    }

    return images
}